import { HTTP } from "./http-common";

const visaRequirementAPI = {
  updateVisaRequirements(visaRequirements) {
    return HTTP.put(`/visa-requirement`, {
      visaRequirements,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CV1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
};

export default visaRequirementAPI;



// WEBPACK FOOTER //
// ./src/api/visaRequirement.js